import { render, staticRenderFns } from "./ClientStats.vue?vue&type=template&id=50380e30&scoped=true&"
import script from "./ClientStats.vue?vue&type=script&lang=js&"
export * from "./ClientStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50380e30",
  null
  
)

export default component.exports